// Content Type - {contentTypeId: <ContentTypeId>, contentTypeName: String}
export const ADD_CONTENT_TYPE = 'content-type:create'; // {...contentType.data, isSingleton: Boolean}
export const MODIFY_CONTENT_TYPE = 'content-type:update'; // {...contentType.data, isSingleton: Boolean}
export const DELETE_CONTENT_TYPE = 'content-type:delete';
// Content Entry - {contentId: <ContentId>, contentTypeName: String, contentTypeId: <ContentTypeId>, isSingleton: Boolean}
export const ADD_CONTENT_ENTRY = 'content:create';
export const MODIFY_CONTENT_ENTRY = 'content:update';
export const DELETE_CONTENT_ENTRY = 'content:delete';
// Site - {siteId: <SiteId>}
export const ADD_STATIC_SITE = 'site:create'; // {...site.data, siteTitle: Object}
export const MODIFY_STATIC_SITE = 'site:update'; // {...site.data, siteTitle: Object}
export const DELETE_STATIC_SITE = 'site:delete';
export const PREVIEW_STATIC_SITE = 'site:preview';
// Site - Publish - {stage: String, siteId: <SiteId>, siteTitle: String}
export const PUBLISH_STARTED = 'site:publish/start';
export const PUBLISH_SUCCEEDED = 'site:publish/success'; // {...publish.data, stats: Object}
export const PUBLISH_FAILED = 'site:publish/failure'; // {...publish.data, error: String}
// Site - Cli - {}
export const CREATE_ACCESS_TOKEN = 'user:create-token';
export const CREATE_SSG_UPLOAD_URL = 'templates:upload'; // {siteId: <SiteId>, stage: String, siteTitle: String}
// Project - {}
export const CREATE_PROJECT = 'project:create'; // {template: <TemplateId>}
export const UPDATE_PROJECT = 'project:update'; // {updatedFields: Array<FieldName>}
export const GET_PROJECT = 'project:get';
export const ADD_PROJECT_AVATAR = 'project:update-avatar';
export const DELETE_PROJECT = 'project:delete';
export const EXPORT_PROJECT = 'project:export';
export const IMPORT_PROJECT = 'project:import';
export const ADD_SERVICE = 'project:add-service';
export const UPDATE_SERVICE = 'project:update-service';
export const REMOVE_SERVICE = 'project:remove-service';
// Project - Schema
export const UPDATE_SCHEMA = 'project:update-schema';
export const GET_SCHEMA = 'project:get-schema';
export const CREATE_OR_UPDATE_SCHEMA = 'project:create-or-update-schema';
export const LIST_SCHEMA_VERSIONS = 'project:list-schema-versions';
export const GET_SCHEMA_VERSIONS = 'project:get-schema-version';
export const CREATE_SCHEMA_BRANCH = 'project:create-schema-branch';
export const DELETE_SCHEMA_BRANCH = 'project:delete-schema-branch';
export const GET_SCHEMA_BRANCH = 'project:get-schema-branch';
export const LIST_SCHEMA_BRANCHES = 'project:list-schema-branches';
export const PROMOTE_SCHEMA_BRANCH = 'project:promote-schema-branch';
export const CREATE_SCHEMA_BRANCH_TAG = 'project:create-schema-branch-tag';
export const DELETE_SCHEMA_BRANCH_TAG = 'project:delete-schema-branch-tag';
export const UPDATE_DEFAULT_LOCALE = 'project:update-default-locale'; // {oldDefaultLocale: <Locale>, newDefaultLocale: <Locale>}
export const ADD_LOCALE = 'project:add-locale'; // {locale: <Locale>, numOfLocales: Number}
export const REMOVE_LOCALE = 'project:remove-locale'; // {locale: <Locale>, numOfLocales: Number}
// Project - Invite - {role: <Role>}
export const CREATE_INVITE = 'project-member:create-invite';
export const ACCEPT_INVITE = 'project-member:accept-invite';
// Project - Member - {affectedUserId: <UserId>}
export const MODIFY_MEMBER_ROLE = 'project-member:update'; // {...member.data, newRole: <Role>, previousRole: <Role>}
export const DELETE_MEMBER = 'project-member:delete'; // {...member.data, role: <Role>}
// Integrations - {provider: <ProviderName>}
export const LINK_INTEGRATION = 'integration:link';
export const UNLINK_INTEGRATION = 'integration:unlink';
export const GET_INTEGRATION_USER = 'integration:get-user';
export const CREATE_INTEGRATION_PUBLISH_TARGET = 'integration:create-publish-target';
export const GET_INTEGRATION_PUBLISH_TARGETS = 'integration:get-publish-targets';
// User - {}
export const CREATE_USER = 'user:create';
export const UPDATE_USER = 'user:update'; // {updatedFields: Array<FieldName>}
export const UPDATE_USER_PASSWORD = 'user:update-password';
export const UPDATE_USER_PREFERENCES = 'user:update-preferences'; // {oldUserPreferences: <UserPreferences>, newUserPreferences: <UserPreferences>}
export const LOGIN_USER = 'user:login';
export const GET_PERSONAL_ACCESS_TOKEN = 'user:get-token';
export const CREATE_PERSONAL_ACCESS_TOKEN = 'user:create-token';
export const DELETE_PERSONAL_ACCESS_TOKEN = 'user:delete-token';
// Api Keys - {apiKeyId: <ApiKeyId>}
export const ADD_API_KEY = 'api-key:create';
export const DELETE_API_KEY = 'api-key:delete';
// Development
export const MOCK_CLAIMS = 'development:mock-claims';
// Other
export const SENT_EMAIL = 'email:send'; // {emailType: String}
export const COMPLETE_SETUP_STEPS = 'setup-steps:update'; // Array<StepKey>
export const API_EXPLORER_SUBMIT = 'api-explorer:submit';
// Resolvers
export const RESOLVER_EXECUTE = 'resolver:execute';
// Cache
export const CACHE_CLEAR = 'cache:clear';
export const CACHE_GET_STATS = 'cache:get-stats';
// Mesh
export const MESH_CREATE = 'mesh:create';
export const MESH_INITIALIZE = 'mesh:initialize';
export const MESH_GET = 'mesh:get';
export const MESH_DELETE = 'mesh:delete';
export const MESH_SYNC = 'mesh:sync';
export const MESH_AUTHORIZE_PROVIDER = 'mesh:authorize-provider';
export const MESH_UPDATE_SERVICES = 'mesh:update-services';
export const MESH_CONTENT_TYPE_ADD = 'mesh-content-type:create';
export const MESH_CONTENT_TYPE_UPDATE = 'mesh-content-type:update';
export const MESH_CONTENT_TYPE_DELETE = 'mesh-content-type:delete';
export const MESH_CONTENT_GET = 'mesh-content:get';
export const MESH_CONTENT_LIST = 'mesh-content:list';
export const MESH_CONTENT_CREATE = 'mesh-content:create';
export const MESH_CONTENT_UPDATE = 'mesh-content:update';
export const MESH_CONTENT_DELETE = 'mesh-content:delete';
// AI Guardrails
export const GUARDRAILS_CREATE_GUARD = 'guardrails:createGuard';
export const GUARDRAILS_UPDATE_GUARD = 'guardrails:updateGuard';
export const GUARDRAILS_DELETE_GUARD = 'guardrails:deleteGuard';
export const GUARDRAILS_LIST_GUARDS = 'guardrails:listGuards';
// AI Administration
export const GET_AGENT_SESSIONS = 'agents:getAgentSessions';
export const GET_AGENT_MESSAGES = 'agents:getAgentMessages';
export const AGENT_TRANSCRIPT__GET = 'agents:agentTranscriptGet';
export const AGENT_TRANSCRIPT__LIST = 'agents:agentTranscriptList';
export const AGENT_TRANSCRIPT__CREATE = 'agents:agentTranscriptCreate';
export const AGENT_TRANSCRIPT__UPDATE = 'agents:agentTranscriptUpdate';
export const AGENT_TRANSCRIPT__DELETE = 'agents:agentTranscriptDelete';
export const AGENT_TRANSCRIPT_TAG__GET = 'agents:agentTranscriptTagGet';
export const AGENT_TRANSCRIPT_TAG__LIST = 'agents:agentTranscriptTagList';
export const AGENT_TRANSCRIPT_TAG__CREATE = 'agents:agentTranscriptTagCreate';
export const AGENT_TRANSCRIPT_TAG__UPDATE = 'agents:agentTranscriptTagUpdate';
export const AGENT_TRANSCRIPT_TAG__DELETE = 'agents:agentTranscriptTagDelete';
export const AGENT_SESSION__CREATE = 'agents:agentSessionCreate';
export const AGENT_MESSAGE__CREATE = 'agents:agentMessageCreate';
export const AGENT__UPDATE = 'agents:agentUpdate';
export const AGENT__GET = 'agents:agentGet';
export const AGENT_LIST__GET = 'agents:agentListGet';
// node - admin-only, will evolve
export const ROOT_NODE__GET = 'root:nodeGet';
